// Centralized reciter catalog. value = al-quran.cloud edition id (used for
// API metadata / display); audioFolder = everyayah.com folder slug used to
// build per-ayah MP3 URLs.
//
// Adding a reciter? Confirm the everyayah folder name with a HEAD on
// `https://everyayah.com/data/<folder>/001001.mp3` first.
//
// Curation policy (mar-2026):
// - Drop bitrate variants below 64kbps (poor audio quality).
// - Drop duplicate folders for the same reciter; keep the highest bitrate.
// - Mujawwad/Murattal styles of the same reciter are kept separately because
//   they're materially different recitations.

export const RECITERS = [
  {
    value: "ar.alafasy",
    label: "Mishary Rashid Alafasy",
    audioFolder: "Alafasy_128kbps",
  },
  {
    value: "ar.abdurrahmaanas-sudais",
    label: "Abdurrahmaan As-Sudais",
    audioFolder: "Abdurrahmaan_As-Sudais_192kbps",
  },
  {
    value: "ar.husary",
    label: "Mahmoud Khalil Al-Husary",
    audioFolder: "Husary_128kbps",
  },
  {
    value: "ar.husary-mujawwad",
    label: "Al-Husary (Mujawwad)",
    audioFolder: "Husary_Mujawwad_64kbps",
  },
  {
    value: "ar.minshawi",
    label: "Mohamed Siddiq El-Minshawi",
    audioFolder: "Minshawy_Murattal_128kbps",
  },
  {
    value: "ar.minshawi-mujawwad",
    label: "El-Minshawi (Mujawwad)",
    audioFolder: "Minshawy_Mujawwad_64kbps",
  },
  {
    value: "ar.shaatree",
    label: "Abu Bakr Ash-Shaatree",
    audioFolder: "Abu_Bakr_Ash-Shaatree_128kbps",
  },
  {
    value: "ar.maher",
    label: "Maher Al-Muaiqly",
    audioFolder: "MaherAlMuaiqly128kbps",
  },
  {
    value: "ar.shuraym",
    label: "Saud Al-Shuraym",
    audioFolder: "Saood_ash-Shuraym_128kbps",
  },
  {
    value: "ar.ajamy",
    label: "Ahmed Ibn Ali Al-Ajamy",
    audioFolder: "Ahmed_ibn_Ali_al-Ajamy_128kbps",
  },
  {
    value: "ar.hudhaify",
    label: "Ali Al-Hudhaify",
    audioFolder: "Hudhaify_128kbps",
  },
  {
    value: "ar.abdulbasit",
    label: "Abdul Basit Abdul Samad",
    audioFolder: "AbdulSamad_64kbps_QuranExplorer.Com",
  },
  {
    value: "ar.abdulbasit-mujawwad",
    label: "Abdul Basit (Mujawwad)",
    audioFolder: "Abdul_Basit_Mujawwad_128kbps",
  },
  {
    value: "ar.abdullahbasfar",
    label: "Abdullah Basfar",
    audioFolder: "Abdullah_Basfar_192kbps",
  },
  {
    value: "ar.hanirifai",
    label: "Hani Ar-Rifai",
    audioFolder: "Hani_Rifai_192kbps",
  },
  {
    value: "ar.salahbukhatir",
    label: "Salah Al-Budair",
    audioFolder: "Salaah_AbdulRahman_Bukhatir_128kbps",
  },
  {
    value: "ar.khalifatantawi",
    label: "Khalifah Al-Tunaiji",
    audioFolder: "khalifa_taj_al_tunaiji_64kbps",
  },
  {
    value: "ar.dossari",
    label: "Yasser Ad-Dossari",
    audioFolder: "Yasser_Ad-Dussary_128kbps",
  },
  {
    value: "ar.nasseralqatami",
    label: "Nasser Al-Qatami",
    audioFolder: "Nasser_Alqatami_128kbps",
  },
  {
    value: "ar.fares",
    label: "Fares Abbad",
    audioFolder: "Fares_Abbad_64kbps",
  },
  {
    value: "ar.ayyub",
    label: "Muhammad Ayyub",
    audioFolder: "Muhammad_Ayyoob_128kbps",
  },
  {
    value: "ar.jibril",
    label: "Muhammad Jibreel",
    audioFolder: "Muhammad_Jibreel_128kbps",
  },
  {
    value: "ar.juhany",
    label: "Abdullah Awad Al-Juhani",
    audioFolder: "Abdullaah_3awwaad_Al-Juhaynee_128kbps",
  },
  {
    value: "ar.qasim",
    label: "Abdul Muhsin Al-Qasim",
    audioFolder: "Muhsin_Al_Qasim_192kbps",
  },
  {
    value: "ar.matrood",
    label: "Abdullah Al-Matrood",
    audioFolder: "Abdullah_Matroud_128kbps",
  },
  {
    value: "ar.akram",
    label: "Akram Al-Alaqimy",
    audioFolder: "Akram_AlAlaqimy_128kbps",
  },
  {
    value: "ar.alisuesy",
    label: "Ali Hajjaj Al-Suesy",
    audioFolder: "Ali_Hajjaj_AlSuesy_128kbps",
  },
  {
    value: "ar.alijaber",
    label: "Ali Jaber",
    audioFolder: "Ali_Jaber_64kbps",
  },
  {
    value: "ar.aymansowaid",
    label: "Ayman Sowaid",
    audioFolder: "Ayman_Sowaid_64kbps",
  },
  {
    value: "ar.aziz",
    label: "Aziz Alili",
    audioFolder: "aziz_alili_128kbps",
  },
  {
    value: "ar.neana",
    label: "Ahmed Neana",
    audioFolder: "Ahmed_Neana_128kbps",
  },
  {
    value: "ar.qahtaani",
    label: "Khalid Al-Qahtani",
    audioFolder: "Khaalid_Abdullaah_al-Qahtaanee_192kbps",
  },
  {
    value: "ar.tablaway",
    label: "Mohammad Al-Tablaway",
    audioFolder: "Mohammad_al_Tablaway_128kbps",
  },
  {
    value: "ar.sahlyassin",
    label: "Sahl Yassin",
    audioFolder: "Sahl_Yassin_128kbps",
  },
  {
    value: "ar.salamah",
    label: "Yaser Salamah",
    audioFolder: "Yaser_Salamah_128kbps",
  },
];

// Quick lookup: edition id → everyayah folder slug.
export const RECITER_FOLDERS = Object.fromEntries(
  RECITERS.map((r) => [r.value, r.audioFolder])
);

// Back-compat aliases for legacy reciter ids that have been removed/renamed.
// Maps old value → current value so saved user prefs still resolve.
export const RECITER_ALIASES = {
  "ar.abdulkareem": "ar.dossari",
  "ar.muaiqly": "ar.maher",
  "ar.mahermuaiqly2": "ar.maher",
  "ar.ruwaiweem": "ar.ajamy",
  "ar.ghamadi": "ar.alafasy",
  "ar.parhizgar": "ar.alafasy",
  "ar.hudhaify64": "ar.hudhaify",
  "ar.tablaway64": "ar.tablaway",
  "ar.shuraym64": "ar.shuraym",
  "ar.ibrahimakhdar": "ar.alafasy",
  "ar.banna": "ar.alafasy",
  "ar.kareemmansoori": "ar.alafasy",
};

export function resolveReciter(value) {
  if (!value) return "ar.alafasy";
  if (RECITER_FOLDERS[value]) return value;
  return RECITER_ALIASES[value] || "ar.alafasy";
}
